<template>
  <div class="row">
    <BrandWizardNavigation :brand-id="$route.params.id" />
    <div class="col">
      <b-card>
        <FormBuilder
          label="Brand"
          update
          :data="$store.getters['brandV2/detailData']"
          :fields="fields"
          :loading-detail="$store.state.brandV2.loadingDetail"
          :loading-submit="$store.state.brandV2.loadingSubmit"
          @load="loadData"
          @submit="submitData"
          @reset="resetData"
        />
      </b-card>
    </div>
  </div>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'
import BrandWizardNavigation from '@/components/brand/BrandWizardNavigation.vue'
import { BCard } from 'bootstrap-vue'
import fields from '@/field/form/brand'

export default {
  components: {
    BCard,
    FormBuilder,
    BrandWizardNavigation,
  },
  setup() {
    return { fields }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('brandV2/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('brandV2/update', { id, data })
        .then(() => {
          if (typeof callback === 'function') callback()
        })
        .catch(err => callback(err))
    },
    resetData() {
      this.$store.commit('brandV2/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>
